var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.1 22.75c-2.12 0-3.85-1.73-3.85-3.85V5.1c0-2.12 1.73-3.85 3.85-3.85h9.8c2.12 0 3.85 1.73 3.85 3.85v13.8c0 2.12-1.73 3.85-3.85 3.85H7.1zM4.75 5.1v13.8c0 1.29 1.05 2.35 2.35 2.35h9.8c1.29 0 2.35-1.05 2.35-2.35V5.1c0-1.29-1.05-2.35-2.35-2.35H7.1c-1.29 0-2.35 1.05-2.35 2.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 13.75c-1.24 0-2.25-1.01-2.25-2.25v-2c0-1.24 1.01-2.25 2.25-2.25h13c1.24 0 2.25 1.01 2.25 2.25v2c0 1.24-1.01 2.25-2.25 2.25h-13zM4.75 9.5v2c0 .41.34.75.75.75h13c.41 0 .75-.34.75-.75v-2c0-.41-.34-.75-.75-.75h-13c-.41 0-.75.34-.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12 18.38c-.06-.05-.11-.12-.16-.19a1.39 1.39 0 0 1-.11-.21c-.04-.08-.06-.16-.08-.24-.01-.08-.02-.16-.02-.24 0-.08.01-.16.02-.24.02-.08.04-.16.08-.24.03-.07.07-.15.11-.21.05-.07.1-.14.16-.19.46-.47 1.29-.47 1.76 0 .06.05.11.12.16.19.04.06.08.14.11.21.04.08.06.16.08.24.01.08.02.16.02.24 0 .08-.01.16-.02.24-.02.08-.04.16-.08.24-.03.07-.07.15-.11.21-.05.07-.1.14-.16.19-.23.24-.55.37-.88.37-.33 0-.65-.13-.88-.37zM15.12 18.38c-.24-.23-.37-.55-.37-.88 0-.33.13-.65.37-.88.46-.47 1.3-.47 1.76 0 .24.23.37.55.37.88 0 .33-.13.65-.37.88-.23.24-.55.37-.88.37-.33 0-.65-.13-.88-.37zM9.5 5.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5c.41 0 .75.34.75.75s-.34.75-.75.75h-5z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBus);
export default __webpack_public_path__ + "static/media/vuesax-outline-bus.725c728d3e08157b4966c9ed9172fedc.svg";
export { ForwardRef as ReactComponent };